(ns frontend.ux-overhaul.listing.kyc.sub
  (:require
   [common.entity :as entity]
   [common.schema.entities.screening-profile.materialization :as sp-materialization]
   [frontend.ux-overhaul.listing.kyc.model :as model]
   [re-frame.core :as rf]))

(rf/reg-sub
 ::state
 (fn [db _]
   (get-in db model/root-path)))

(rf/reg-sub
 ::selected-profile-id
 :<-
 [::state]
 (fn [state _]
   (get state model/selected-profile-id-key)))

(rf/reg-sub
 ::entities
 :<-
 [::state]
 (fn [state _]
   (get state model/entities-key)))

(rf/reg-sub
 ::bulk-edit-open?
 :<-
 [::state]
 (fn [state _]
   (boolean (get state model/bulk-edit-open?-key))))

(rf/reg-sub
 ::selected-profile
 :<- [::selected-profile-id]
 :<- [::entities]
 (fn [[id entities] _]
   (when id
     (get entities id))))

(defn entity-lookup
  [entities id]
  (if-let [entity (get entities id)]
    entity
    (if (:db/id id)
      (do (js/console.warn "Entity lookup called with entity in screening sub " id)
          id)
      (js/console.warn "Entity not found in screening sub : " id))))

(rf/reg-sub
 ::kyc-profiles-and-pep-statuses
 :<-
 [::selected-profile]
 :<-
 [::entities]
 (fn [[screening-profile entities] _]
   (let [entity-lookup (partial entity-lookup entities)
         display-string (fn [& args]
                          (apply entity/display-string args))]
     (when screening-profile
       (sp-materialization/screening-profile->kyc-profiles-and-pep-statuses
        {:screening-profile screening-profile
         :entity-lookup     entity-lookup
         :display-string    display-string})))))

(rf/reg-sub
 ::counterparty-diligences-and-pep-statuses
 :<-
 [::selected-profile]
 :<-
 [::entities]
 (fn [[screening-profile entities] _]
   (let [entity-lookup (partial entity-lookup entities)
         display-string (fn [& args]
                          (apply entity/display-string args))]
     (when screening-profile
       (sp-materialization/screening-profile->counterparty-diligences-and-pep-statuses
        {:screening-profile screening-profile
         :entity-lookup     entity-lookup
         :display-string    display-string})))))

(rf/reg-sub
 ::pep-or-rca-mismatch-data
 (fn [_]
   [(rf/subscribe [::selected-profile])
    (rf/subscribe [::kyc-profiles-and-pep-statuses])
    (rf/subscribe [::counterparty-diligences-and-pep-statuses])])
 (fn [[screening-profile kyc-profiles-and-pep-statuses counterparty-diligences-and-pep-statuses]]
   (when screening-profile
     (sp-materialization/calculate-pep-or-rca-mismatch-data
      {:screening-profile                        screening-profile
       :kyc-profiles-and-pep-statuses            kyc-profiles-and-pep-statuses
       :counterparty-diligences-and-pep-statuses counterparty-diligences-and-pep-statuses}))))
